

import { DateTime } from 'luxon';
import { ChangeEventHandler, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch } from 'react-redux';
import { getDateTimeFromServerTime } from '../../app/dates';
import { AppDispatch } from '../../app/store';
import { useAuth } from '../signin/auth';
import { writeChecklistItem } from './checklistSlice';
import { ChecklistItem } from './types';

interface ChecklistItemCompletedInputProps {
  item: ChecklistItem;
  onChange: (completed: Boolean) => void;
  className?: string | undefined;
  disabled: boolean;
};

ChecklistItemCompletedInput.defaultProps = {
  disabled: false,
  onChange: () => { },
};

function ChecklistItemCompletedInput(props: ChecklistItemCompletedInputProps) {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const { item, onChange, className, disabled } = props;
  const [isChecked, setChecked] = useState(item.completedOn !== null);
  const [isDisabled, setDisabled] = useState(disabled);

  const onChecked: ChangeEventHandler = async (e) => {
    if (auth.authToken) {
      const newCheckedValue = !isChecked;
      setDisabled(true);
      await dispatch(writeChecklistItem({
        authToken: auth.authToken,
        checklistItem: {
          ...item,
          completedOn: newCheckedValue ? new Date() : null,
        }
      }));
      setDisabled(false);
      setChecked(newCheckedValue);
      onChange(newCheckedValue);
    } else {
      console.log('No auth token!')
    }
  }

  return (
    <div className="d-flex flex-row align-items-center">
      <div className="flex-fill">
        {isChecked && (item.completedOn !== null) && (
          <div className="form-text text-muted">{getDateTimeFromServerTime(item.completedOn).toLocaleString(DateTime.DATETIME_SHORT)}</div>
        )}
      </div>
      <div className="ms-2">
        <Form.Check className={className} id={`item-${item.id}-completed`} checked={isChecked} onChange={onChecked} disabled={isDisabled} />
      </div>
    </div>
  );
}

export default ChecklistItemCompletedInput;